export const stats = {
  "users": 126000,
  "rating": {
    "average": 4.8,
    "count": 2162,
    "5": 1945,
    "4": 126,
    "3": 51,
    "2": 7,
    "1": 33
  },
}